(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-bundle-picker]');
  if (!root) return;

  var FREE_SHIP_CENTS = 4500;

  var state = {
    tierTitle: '',
    tierSize: 0,
    cart: null,
  };
  var busy = false;

  var productMap = {};
  root.querySelectorAll('[data-product-id]').forEach(function (el) {
    productMap[el.dataset.productId] = {
      el: el,
      variantId: parseInt(el.dataset.variantId, 10),
      variantIds: (el.dataset.variantIds || '')
        .split(',')
        .map(function (s) { return parseInt(s, 10); })
        .filter(function (n) { return n; }),
      title: el.dataset.productTitle,
      price: parseFloat(el.dataset.productPrice) || 0,
      qtyEl: el.querySelector('[data-qty]'),
      addEl: el.querySelector('[data-action="add"]'),
      decEl: el.querySelector('[data-action="dec"]'),
      incEl: el.querySelector('[data-action="inc"]'),
      countEl: el.querySelector('[data-count]'),
    };
  });

  var els = {
    count: root.querySelector('[data-picker-count]'),
    sub: root.querySelector('[data-picker-sub]'),
    summaryTitle: root.querySelector('[data-summary-title]'),
    summaryMeta: root.querySelector('[data-summary-meta]'),
    summaryEmpty: root.querySelector('[data-summary-empty]'),
    summarySize: root.querySelector('[data-summary-size]'),
    summaryLines: root.querySelector('[data-summary-lines]'),
    summaryTotal: root.querySelector('[data-summary-total]'),
    meterText: root.querySelector('[data-meter-text]'),
    meterRemaining: root.querySelector('[data-meter-remaining]'),
    meterFill: root.querySelector('[data-meter-fill]'),
    meterBar: root.querySelector('[data-meter-bar]'),
    cta: root.querySelector('[data-add-bundle]'),
    ctaLabel: root.querySelector('[data-cta-label]'),
    feedback: root.querySelector('[data-feedback]'),
  };

  function setTier(btn) {
    state.tierKey = btn.dataset.tierKey;
    state.tierTitle = btn.dataset.tierTitle;
    state.tierSize = parseInt(btn.dataset.tierSize, 10) || 0;

    root.querySelectorAll('.bundle-picker__tier').forEach(function (b) {
      var active = b === btn;
      b.classList.toggle('bundle-picker__tier--active', active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (els.summaryTitle) els.summaryTitle.textContent = state.tierTitle;
    if (els.summaryMeta) els.summaryMeta.textContent = state.tierSize + ' Bags';
    if (els.summarySize) els.summarySize.textContent = state.tierSize;
    if (els.sub) els.sub.textContent = 'Choose ' + state.tierSize + ' bags to complete ' + state.tierTitle + '.';

    render();
  }

  // ── Cart-derived quantities (the live cart is the source of truth) ──
  // Match ANY variant of the product — a shopper may have added a size/grind
  // variant that isn't this card's primary add-variant, but it's still the
  // same coffee and must count toward the tally + summary.
  function matchesProduct(p, it) {
    return p.variantIds.length
      ? p.variantIds.indexOf(it.variant_id) !== -1
      : it.variant_id === p.variantId;
  }

  function qtyOf(productId) {
    var p = productMap[productId];
    if (!p || !state.cart || !state.cart.items) return 0;
    var n = 0;
    state.cart.items.forEach(function (it) {
      if (matchesProduct(p, it)) n += it.quantity;
    });
    return n;
  }

  // Every cart line (key + current quantity) belonging to this product —
  // a product may span several lines when added under different variants.
  function matchingLinesOf(productId) {
    var p = productMap[productId];
    if (!p || !state.cart || !state.cart.items) return [];
    return state.cart.items
      .filter(function (it) { return matchesProduct(p, it); })
      .map(function (it) { return { key: it.key, quantity: it.quantity }; });
  }

  function totalSelected() {
    var n = 0;
    Object.keys(productMap).forEach(function (id) { n += qtyOf(id); });
    return n;
  }

  function bundleSubtotalCents() {
    var sum = 0;
    Object.keys(productMap).forEach(function (id) {
      sum += Math.round(productMap[id].price * 100) * qtyOf(id);
    });
    return sum;
  }

  function syncCart() {
    if (window.KirschCart && window.KirschCart.refresh) {
      window.KirschCart.refresh();
    } else {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { state.cart = c; render(); })
        .catch(function () {});
    }
  }

  function setBusy(b) {
    busy = b;
    root.classList.toggle('is-busy', b);
  }

  // ── Write-through cart mutations (+/- modify the real cart) ──
  function addOne(productId) {
    var p = productMap[productId];
    if (!p || busy) return;
    setBusy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] }),
    }).then(afterMutate).catch(onMutateError);
  }

  function changeBy(productId, delta) {
    var p = productMap[productId];
    if (!p || busy) return;
    if (delta > 0) { addOne(productId); return; }
    // Decrement ONE concrete cart line by one. Under multi-variant matching a
    // product can span several lines, so reduce a specific line rather than
    // applying an aggregate quantity to a single key (which could no-op or
    // even raise the total).
    var lines = matchingLinesOf(productId);
    if (!lines.length) return;
    var target = lines[lines.length - 1];
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: target.key, quantity: Math.max(0, target.quantity - 1) }),
    }).then(afterMutate).catch(onMutateError);
  }

  function afterMutate(res) {
    setBusy(false);
    if (!res || !res.ok) { onMutateError(); return; }
    syncCart();
  }

  function onMutateError() {
    setBusy(false);
    showFeedback('Something went wrong. Please try again.', true);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function render() {
    var total = totalSelected();
    var remaining = Math.max(0, state.tierSize - total);
    var ready = total >= state.tierSize && total > 0;

    if (els.count) {
      els.count.textContent = total + ' / ' + state.tierSize;
      els.count.classList.toggle('is-complete', ready);
    }

    Object.keys(productMap).forEach(function (id) {
      var p = productMap[id];
      var qty = qtyOf(id);
      p.el.classList.toggle('is-selected', qty > 0);
      if (qty === 0) {
        if (p.addEl) { p.addEl.hidden = false; p.addEl.disabled = busy; }
        if (p.qtyEl) p.qtyEl.hidden = true;
      } else {
        if (p.addEl) p.addEl.hidden = true;
        if (p.qtyEl) p.qtyEl.hidden = false;
        if (p.countEl) p.countEl.textContent = qty;
        if (p.incEl) p.incEl.disabled = busy;
        if (p.decEl) p.decEl.disabled = busy;
      }
    });

    var selectedIds = Object.keys(productMap).filter(function (id) { return qtyOf(id) > 0; });
    if (selectedIds.length === 0) {
      els.summaryEmpty.hidden = false;
      els.summaryLines.hidden = true;
      els.summaryLines.innerHTML = '';
    } else {
      els.summaryEmpty.hidden = true;
      els.summaryLines.hidden = false;
      els.summaryLines.innerHTML = selectedIds.map(function (id) {
        var p = productMap[id];
        var qty = qtyOf(id);
        return '<li><span>' + qty + '\u00d7 ' + p.title + '</span><small>' + formatMoney(Math.round(p.price * 100) * qty) + '</small></li>';
      }).join('');
    }

    els.summaryTotal.textContent = formatMoney(bundleSubtotalCents());

    // The free-shipping meter reflects the WHOLE cart (free shipping is
    // cart-wide), so a roast added anywhere on the site moves it.
    var cartTotal = state.cart ? state.cart.total_price : 0;
    var remCents = Math.max(0, FREE_SHIP_CENTS - cartTotal);
    var pct = Math.min(100, (cartTotal / FREE_SHIP_CENTS) * 100);
    els.meterFill.style.width = pct + '%';
    els.meterBar.setAttribute('aria-valuenow', Math.round(pct));

    if (remCents === 0 && cartTotal > 0) {
      els.meterText.innerHTML = '<strong>Your order qualifies for FREE shipping</strong> <span class="shipping-meter__sub">to the Continental US.</span>';
    } else {
      els.meterText.innerHTML = 'You\u2019re <strong>' + formatMoney(remCents) + '</strong> away from <strong>FREE shipping</strong> <span class="shipping-meter__sub">to the Continental US.</span>';
    }

    if (total === 0) {
      els.cta.disabled = true;
      els.ctaLabel.textContent = 'Add roasts to begin';
    } else if (!ready) {
      els.cta.disabled = false;
      els.ctaLabel.textContent = 'View cart \u2014 ' + remaining + ' more for ' + (state.tierTitle || 'the trio');
    } else {
      els.cta.disabled = false;
      els.ctaLabel.textContent = 'Review & checkout';
    }
  }

  function showFeedback(msg, isError) {
    if (!els.feedback) return;
    els.feedback.textContent = msg;
    els.feedback.hidden = false;
    els.feedback.classList.toggle('is-error', !!isError);
  }

  root.querySelectorAll('.bundle-picker__tier').forEach(function (btn) {
    btn.addEventListener('click', function () { setTier(btn); });
  });

  root.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-desc-toggle]');
    if (toggle) {
      var card = toggle.closest('[data-product-id]');
      if (!card) return;
      var desc = card.querySelector('[data-desc]');
      if (!desc) return;
      var open = !desc.hidden;
      desc.hidden = open;
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      toggle.textContent = open ? 'Description' : 'Hide';
      return;
    }
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var card = btn.closest('[data-product-id]');
    if (!card) return;
    var action = btn.dataset.action;
    var id = card.dataset.productId;
    if (action === 'add' || action === 'inc') changeBy(id, 1);
    else if (action === 'dec') changeBy(id, -1);
  });

  els.cta.addEventListener('click', function () {
    if (els.cta.disabled) return;
    window.location.href = '/cart';
  });

  // Re-render whenever the global cart changes — adds from Featured Roasts,
  // product pages, this picker, or the cart page all flow through here.
  document.addEventListener('kirsch:cart', function (e) {
    state.cart = e.detail;
    render();
  });

  var initial = root.querySelector('.bundle-picker__tier--active') || root.querySelector('.bundle-picker__tier');
  if (initial) setTier(initial);

  // Load the live cart so the tally + meter reflect what's already chosen.
  syncCart();

  // Carry over a roast chosen on a product page (/?add=handle#bundle-picker):
  // add it to the cart once, strip the param so a refresh won't re-add it, then
  // scroll the shopper to their bundle in progress.
  var addHandle = new URLSearchParams(window.location.search).get('add');
  if (addHandle) {
    var safe = addHandle.replace(/[^a-z0-9\-]/gi, '');
    var match = root.querySelector('[data-product-handle="' + safe + '"]');
    if (match) {
      addOne(match.dataset.productId);
      var params = new URLSearchParams(window.location.search);
      params.delete('add');
      var qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : '') + '#bundle-picker');
      requestAnimationFrame(function () {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
